import { TaskStatus, TaskStatusEnum } from "@dune/types";
import { Badge } from "@dune/ui";

interface TaskStatusBadgeProps {
	status: TaskStatus;
	className?: string;
}

const getTaskStatusLabel = (status: TaskStatus): string => {
	switch (status) {
		case TaskStatusEnum.TO_DO:
			return "À faire";
		case TaskStatusEnum.IN_PROGRESS:
			return "En cours";
		case TaskStatusEnum.DONE:
			return "Terminé";
		default:
			return status;
	}
};

const getTaskStatusColorClasses = (status: TaskStatus): string => {
	switch (status) {
		case TaskStatusEnum.TO_DO:
			return "bg-gray-100 text-gray-800 border-gray-300";
		case TaskStatusEnum.IN_PROGRESS:
			return "bg-blue-100 text-blue-800 border-blue-300";
		case TaskStatusEnum.DONE:
			return "bg-green-100 text-green-800 border-green-300";
		default:
			return "bg-gray-100 text-gray-800 border-gray-300";
	}
};

export const TaskStatusBadge: React.FC<TaskStatusBadgeProps> = ({
	status,
	className,
}) => {
	return (
		<Badge
			className={`${getTaskStatusColorClasses(status)} ${className || ""}`}
		>
			{getTaskStatusLabel(status)}
		</Badge>
	);
};
